import {useCallback, useEffect} from 'react'

const useEscapeKey = (handleClose: (event) => void) => {
	const handleEscKey = useCallback(
		event => {
			if (event.key === 'Escape') {
				handleClose(event)
			}
		},
		[handleClose],
	)

	useEffect(() => {
		document.addEventListener('keyup', handleEscKey, false)

		return () => {
			document.removeEventListener('keyup', handleEscKey, false)
		}
	}, [handleEscKey])
}

export default useEscapeKey
